import { useState } from "react";
import { CONTENT } from "@/content";
import { BorderBeam } from "@/components/ui/border-beam";
import { Reveal } from "../ui/Reveal";
import { SecHead } from "./SecHead";
import { motion, AnimatePresence } from "framer-motion";
type Props = {
  onCTA: () => void;
  onWhats: () => void;
};

export function FAQ({ onCTA, onWhats }: Props) {
  const f = CONTENT.faq;
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="section faq" id="faq">
      <div className="wrap">
        <SecHead label={f.label} title={f.title} />
        <div className="faq-list">
          {f.items.map(([q, a], i) => (
            <Reveal as="div" key={i} className={`faq-item ${open === i ? "open" : ""}`}>
              <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)}>
                <span className="faq-q-n">{String(i + 1).padStart(2, "0")}</span>
                <span className="faq-q-t serif">{q}</span>
                <span className="faq-q-ic" aria-hidden="true">
                  <i />
                  <i />
                </span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                    className="faq-a-wrap"
                    style={{ overflow: 'hidden' }}
                  >
                    <div className="faq-a">
                      {a.map((p, j) => (
                        <p key={j}>{p}</p>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </Reveal>
          ))}
        </div>
        <Reveal className="faq-foot">
          <p className="faq-closing serif">{f.closing}</p>
          <div className="faq-foot-actions">
            <button className="btn btn-primary btn-lg btn-beam btn-beam-primary" onClick={onCTA}>
              <BorderBeam />
              {f.cta} <span className="arr">→</span>
            </button>
            <button className="btn btn-whats" onClick={onWhats}>
              {f.ctaWhats}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
